{
  "id": "cytoscape-seam-explorer-csk-seams",
  "kind": "cytoscape_seam_explorer",
  "title": "Cytoscape Seam Explorer — CSK Seam Crossings",
  "cytoscape_seam_explorer": {
    "interactive": {
      "backend": "cytoscape_js",
      "static_fallback": "cytoscape-seam-explorer-csk-seams-static",
      "csp_constraint": "self_only"
    },
    "layout_algorithm": "cose",
    "nodes": [
      { "id": "data_origin", "label": "DATA.ORIGIN", "seam_class": "data_origin" },
      { "id": "data_reach", "label": "DATA.REACH", "seam_class": "data_reach" },
      { "id": "permit", "label": "PERMIT", "seam_class": "permit" },
      { "id": "separate", "label": "SEPARATE", "seam_class": "separate" },
      { "id": "precommit", "label": "PRECOMMIT", "seam_class": "precommit" }
    ],
    "edges": [
      { "from": "data_origin", "to": "data_reach", "label": "DATA.LINEAGE" },
      { "from": "permit", "to": "data_reach", "label": "delegate" },
      { "from": "separate", "to": "permit", "label": "scope" },
      { "from": "precommit", "to": "data_reach", "label": "freeze" }
    ],
    "title": "Filterable seam-crossing map"
  },
  "theorems": ["P", "S", "W"],
  "theory_refs": [
    "theory/structural/SEAM-NORMAL-FORM.md"
  ],
  "metadata": {
    "theorems": ["P", "S", "W"],
    "tags": ["interactive", "cytoscape", "seam"],
    "description": "Seam-crossing topology rendered via Cytoscape.js with cose layout. Each node tags its seam class so the client-side renderer can filter; static fallback id supplies the offline snapshot. Backend pinned to cytoscape_js by the runtime invariant."
  }
}
